import React from 'react';
import { Stack } from '@mui/material'
import PersonalInformation from './PersonalInformation';
import Credentials from './Credentials';
import { ADMIN, CLIENT, PERSON, Role, STAFF, HEADSALES, VENDOR, MANAGER } from '../../../models/User';


export type PersonType = typeof personTypes[number]

export const personTypes = ["C",  "V",  "D",  "P",  "S",  "O", "A", "H", "M", "U", ""]
export const visiblePersonTypes = ["C",  "V",  "S", "A", "H", "M", ""]

export const personTypeToDescription = (type: PersonType): string => {
  switch (type) { 
    case 'C': return "client"
    case 'V': return "vendor"
    case 'D': return "driver"
    case 'P': return "provider"
    case 'S': return "staff"
    case 'O': return "other"
    case 'A': return "admin"
    case 'H': return "headsales"
    case 'M': return "manager"
    case 'U': return "person"
  }
  return "not"
}

export const roleToPersonType = (role: Role): PersonType => {
  switch (role) { 
    case ADMIN: return "A"
    case CLIENT: return "C"
    case VENDOR: return "V"
    case STAFF: return "S"
    case PERSON: return "P"
    case HEADSALES: return "H"
    case MANAGER: return "M"
  }
  return ""
}

export const PersonTypeToRoleId = ( pt: PersonType ) => {
  switch( pt ) 
  {
    case 'A': return 1;
    case 'U': return 2;
    case 'C': return 3;
    case 'V': return 4;
    case 'D': return 5;
    case 'P': return 9;
    case 'S': return 6;
    case 'H': return 7;
    case 'M': return 8;
    case 'O': return 99;
  }
}


const Profile: React.FC = () => {
  return (
  <Stack display="flex" flexDirection="row">
    <PersonalInformation/>
    <Credentials/>
  </Stack>
  )
}

export default Profile

